import { useCallback, useEffect } from "react"
import { useNavigate } from "react-router"
import { onAuthStateChanged } from "firebase/auth"
import { auth } from "@/api/firebase"
import { SESSION_KEY } from "@/hooks/common/auth"
import { useGoogleSignIn } from "@/hooks/common"
import { useHasTrips } from "@/hooks/useHasTrips"
import { useSessionGuard } from "@/hooks/useSessionGuard"

import {
  HeroSection,
  GridSection,
  SuggestionsGrid,
  Footer,
  R3FScene,
  LandingHeader,
} from '@/components/landing'

export default function LandingPage() {
  const navigate = useNavigate()
  const { hasTrips, loading: tripsLoading } = useHasTrips()
  const { isAuthed, initializing } = useSessionGuard()
  const { signIn } = useGoogleSignIn()

  const handleSignIn = useCallback(async () => {
    const result = await signIn()
    if (!result.success && result.isNewUser && result.error) {
      // User creation failed, redirect to display name page
      navigate("/display-name")
    }
    // Stay on landing page - useEffect will redirect if user has trips
  }, [signIn, navigate])

  // Auto-redirect authenticated users with trips to globe
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      const expiresAt = Number(localStorage.getItem(SESSION_KEY) ?? 0)

      // If authenticated with valid session and has trips, go to globe
      if (user && expiresAt > Date.now() && !tripsLoading) {
        if (hasTrips) {
          navigate("/trips", { replace: true })
        }
        // If authenticated but no trips, stay on landing page
      }
    })
    return () => unsub()
  }, [navigate, hasTrips, tripsLoading])

  return (
    <main className="w-full flex flex-col relative">
      <LandingHeader isAuthed={isAuthed} initializing={initializing} onSignInClick={handleSignIn} />
      <HeroSection />
      <GridSection />
      <R3FScene/>
      <SuggestionsGrid />
      <Footer />
    </main>
  )
}
